import { TenantContext } from '@/components';
import { usersRepo } from '@/constants/providers';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { UserKey } from './types';

type UseGetUsersBaseInfoProps = {
  searchTerm?: string;
  businessAreaId?: number;
};

export const useGetUsersBaseInfo = (
  { searchTerm, businessAreaId }: UseGetUsersBaseInfoProps = {},
  options: { disabled?: boolean } = {},
) => {
  const { currentSelectedTenant } = useContext(TenantContext);
  return useQuery(
    [
      ...UserKey.BASE_INFO,
      { searchTerm, businessAreaId },
      currentSelectedTenant?.id,
    ],
    () => usersRepo.getAllUsersBaseInfo({ searchTerm, businessAreaId }),
    { enabled: !options.disabled },
  );
};
